var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6915 7.27083C13.6915 9.85967 11.5928 11.9583 9.00399 11.9583C6.41515 11.9583 4.31649 9.85967 4.31649 7.27083C4.31649 4.682 6.41515 2.58333 9.00399 2.58333C11.5928 2.58333 13.6915 4.682 13.6915 7.27083ZM15.7748 7.27083C15.7748 11.0103 12.7434 14.0417 9.00399 14.0417C5.26456 14.0417 2.23315 11.0103 2.23315 7.27083C2.23315 3.53141 5.26456 0.5 9.00399 0.5C12.7434 0.5 15.7748 3.53141 15.7748 7.27083ZM3.2749 15.0835C1.54901 15.0835 0.149902 16.4826 0.149902 18.2085V19.2502C0.149902 19.8255 0.616272 20.2918 1.19157 20.2918C1.76687 20.2918 2.23324 19.8255 2.23324 19.2502V18.2085C2.23324 17.6332 2.69961 17.1668 3.2749 17.1668H14.7332C15.3085 17.1668 15.7749 17.6332 15.7749 18.2085V19.2502C15.7749 19.8255 16.2413 20.2918 16.8166 20.2918C17.3919 20.2918 17.8582 19.8255 17.8582 19.2502V18.2085C17.8582 16.4826 16.4591 15.0835 14.7332 15.0835H3.2749Z",
    fill: "#C1C1C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.bb094a80254eedbb8de96e21d48d8a5a.svg";
export { ForwardRef as ReactComponent };